import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectSelectedCurrency } from '../../../../../../store/user';
import ShowCurrencies from '../../../../../../utils/showCurrencies';
import { generateLinkWithLang } from '../../../../../../utils/linkGenerator';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { CloseIcon } from '../../../../../../components/general/customIcons';
import CustomButton from '../../../../../../components/general/button';

const AppealDetailsResultSection = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const {
    selectedGivingProducts = [],
    isMinimized = false,
    showMoreItems = false,
    handleRemoveProduct,
    setShowMoreItems,
    handleMinimize,
    lang = 'en',
  } = props;
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const navigate = useNavigate();
  /* ------------------------------ Start methods ----------------------------- */

  /* ------------------------------- Start hooks ------------------------------ */

  /* -------------------------------------------------------------------------- */

  return (
    <div className="fixed bottom-0 [&>div]:w-full z-[199] shadow-[rgba(189,189,189,0.5)_0px_-15px_25px_-1px] w-full left-0 p-2 bg-LighterBlue">
      <div className="flex flex-col gap-1 items-center w-full justify-around mx-auto p-2 rounded-lg bg-white">
        <div className={`flex w-full flex-col border-b border-stone-300 ${isMinimized ? '' : 'mb-1'} pb-1 cursor-pointer`} onClick={handleMinimize}>
          <h2 className={`text-DarkerBlue text-lg md:text-2xl w-full font-bold w-100 flex justify-between`}>
            Your Giving Amount{' '}
            <ChevronDownIcon
              className={`w-4 h-4 cursor-pointer text-stone-600 transition-all duration-300 ${isMinimized ? ' transform rotate-180' : ''}`}
            />
          </h2>
          <div className="flex items-center">
            <span className="text-DarkerBlue text-sm">{selectedGivingProducts.products.length} items in Cart</span>
            <span className="text-LightBlue text-sm cursor-pointer ml-2" onClick={() => navigate(generateLinkWithLang('/checkout', lang))}>
              View Cart
            </span>
          </div>
        </div>
        <div className={`transition-all duration-300 w-full ${isMinimized ? 'h-0' : 'h-auto'} overflow-hidden`}>
          <div className="flex justify-between items-center flex-col py-1 w-full border-b border-stone-200 max-h-[160px] overflow-y-auto">
            {selectedGivingProducts.products.map((item, index) => {
              if (showMoreItems) {
                return (
                  <div key={`giving${index}`} className="w-full flex items-center justify-between mb-1">
                    <div className="text-stone-400 text-xs flex items-center">
                      <CloseIcon className="w-4 h-4 text-stone-400 mr-2 cursor-pointer" onClick={() => handleRemoveProduct(item)} />
                      <p className="text-stone-400 text-xs">{item.name}</p>
                    </div>
                    <div className="text-xs text-DarkerBlue">
                      {ShowCurrencies(selectedCurrencyStore, item.quantity * item[selectedCurrencyStore.toLowerCase()], false)}
                    </div>
                  </div>
                );
              } else {
                return (
                  index < 2 && (
                    <div key={`giving${index}`} className="w-full flex items-center justify-between mb-1">
                      <div className="text-stone-400 text-xs flex items-center">
                        <CloseIcon className="w-4 h-4 text-stone-400 mr-2 cursor-pointer" onClick={() => handleRemoveProduct(item)} />
                        <p className="text-stone-400 text-xs">{item.name}</p>
                      </div>
                      <div className="text-xs text-DarkerBlue">
                        {ShowCurrencies(selectedCurrencyStore, item.quantity * item[selectedCurrencyStore.toLowerCase()], false)}
                      </div>
                    </div>
                  )
                );
              }
            })}
          </div>
          {selectedGivingProducts.products.length > 2 && (
            <div className="flex border-b border-stone-200 pb-2">
              <span className="text-LightBlue text-xs flex items-center cursor-pointer mt-1" onClick={() => setShowMoreItems(!showMoreItems)}>
                {showMoreItems ? (
                  <>
                    Show less items <ChevronDownIcon className={`w-3 h-3 text-stone-500 ml-2`} />
                  </>
                ) : (
                  <>
                    View more items <ChevronUpIcon className={`w-3 h-3 text-stone-500 ml-2`} />
                  </>
                )}
              </span>
            </div>
          )}
          <div className="flex justify-between items-center border-t border-stone-300 py-1 w-full">
            <p className="text-stone-500 text-xs">Total Amount</p>
            <div className="text-sm font-bold text-DarkerBlue">{ShowCurrencies(selectedCurrencyStore, selectedGivingProducts.total, false)}</div>
          </div>
        </div>
        <div className="flex items-center mt-1 w-full">
          <CustomButton
            title={
              <>
                <span className="mr-1">Give</span>
                {ShowCurrencies(selectedCurrencyStore, selectedGivingProducts.total, false)}
              </>
            }
            link={'/checkout'}
            className={`${lang === 'ar' ? '' : 'font-["Montserrat"]'} font-bold w-full`}
          />
        </div>
      </div>
    </div>
  );
};

export default AppealDetailsResultSection;
